import React from 'react';
import PropTypes from 'prop-types';
import ButtonTooltip from '../ButtonTooltip/ButtonTooltip';

import withIdContext from '../../decorators/withIdContext';

const SuppressedAction = ({
  disabled,
  label,
  onClick,
  type,
  disabledReason,
  disabledReasonPlacement,
}) => (
  <ButtonTooltip
    btStyle="link"
    type={type}
    disabled={disabled}
    onClick={onClick}
    disabledReason={disabledReason}
    disabledReasonPlacement={disabledReasonPlacement}
    label={label}
  />
);

SuppressedAction.propTypes = {
  /** Button label */
  label: PropTypes.string,
  /** Button type */
  type: PropTypes.oneOf(['button', 'reset', 'submit']),
  /** Disable button */
  disabled: PropTypes.bool,
  /** Gets called when the user clicks on the button */
  onClick: PropTypes.func.isRequired,
  /** The tooltip describing why the action is disabled */
  disabledReason: PropTypes.string,
  /** Where the tooltip should pop up relative to the action */
  disabledReasonPlacement: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
};

SuppressedAction.defaultProps = {
  label: '',
  type: 'button',
  disabled: false,
  disabledReason: null,
  disabledReasonPlacement: 'top',
};

export default withIdContext()(SuppressedAction);
